export default __webpack_public_path__ + "99bb6135a11505f40cf20925e82e8fb1.png";